import React from 'react';

import styles from './MLDataModal.module.scss';
import { PositionModal, PositionModalProps } from '../../../shared/modal/PositionModal';
import { Toggle } from '../../../shared/toggle';

interface MLDataSettingsModalProps extends PositionModalProps {
    reorderCheckedQueries: boolean;
    setReorderCheckedQueries: (value: boolean) => void;
    includePreviousQueries: boolean;
    setIncludePreviousQueries: (value: boolean) => void;
    showMoveCheckedQueries: boolean;
}

export const MLDataSettingsModal: React.FC<MLDataSettingsModalProps> = ({
    reorderCheckedQueries,
    setReorderCheckedQueries,
    includePreviousQueries,
    setIncludePreviousQueries,
    closeModal,
    isOpen,
    testId,
    position,
    showMoveCheckedQueries
}) => (
    <PositionModal
        isOpen={isOpen}
        closeModal={closeModal}
        position={position}
        testId={testId}
        height='fit-content'
        renderLeftOfClick
        width='320px'
        overflow='none'
    >
        <div className={styles.mlPreviousQueriesSettingsWrapper}>
            {showMoveCheckedQueries && <div className={styles.mlPreviousQueriesSettings}>
                <div className={styles.mlPreviousQueriesHeader}>Move queries you are happy to proceed with to the bottom</div>
                <Toggle checked={reorderCheckedQueries} onChange={() => setReorderCheckedQueries(!reorderCheckedQueries)} />
            </div>}
            <div className={styles.mlPreviousQueriesSettings}>
                <div className={styles.mlPreviousQueriesHeader}>Include data already populated from previous iterations of the AI algorithm</div>
                <Toggle checked={includePreviousQueries} onChange={() => setIncludePreviousQueries(!includePreviousQueries)} />
            </div>
        </div>
    </PositionModal>
);
